import React from 'react';
import { Box } from '@wix/design-system';
import { WidgetButton } from '../../../CommonWidgets/shared/WidgetButton/WidgetButton';
import { WidgetLayout } from '../../../CommonWidgets/shared/WidgetLayout/WidgetLayout';
import { WithDisabledControl } from '../../../../shared/disabled-widget/WithDisabledControl';
import { StyledMarkdownText } from '../../ProactiveMarketingAssistant/common/TextTyper/StyledMarkdownText';
import styles from './RestoreNotificationWidget.module.scss';
export const RestoreNotificationWidget = _ref => {
  let {
    data: {
      button,
      text,
      messageIndexToScrollTo
    },
    context,
    config
  } = _ref;
  const areControlsDisabled = false;
  const {
    position = 'left'
  } = button || {};
  const handleButtonClick = function (action, label) {
    if (label === void 0) {
      label = '';
    }
    const handler = effects => {
      if (typeof messageIndexToScrollTo === 'number') {
        config.scrollToMessage == null || config.scrollToMessage({
          messageIndex: messageIndexToScrollTo
        });
      }
      const onWidgetActionData = {
        action,
        value: {
          label,
          effects
        }
      };
      context.onWidgetAction(RESTORE_NOTIFICATION_WIDGET, onWidgetActionData);
    };
    return handler;
  };
  return /*#__PURE__*/React.createElement(WidgetLayout, {
    context: context,
    disabled: areControlsDisabled,
    onEnableControls: () => {}
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    boxSizing: "border-box",
    containerType: "inline-size",
    gap: "10px"
  }, text && /*#__PURE__*/React.createElement(StyledMarkdownText, null, text), /*#__PURE__*/React.createElement(Box, {
    align: position
  }, (button == null ? void 0 : button.label) && /*#__PURE__*/React.createElement(WithDisabledControl, {
    t: context.t,
    isDisabled: areControlsDisabled,
    onEnable: () => {}
  }, /*#__PURE__*/React.createElement(WidgetButton, {
    className: position === 'left' ? styles.restoreNotificationButton : undefined,
    context: context,
    onClick: handleButtonClick('primary_button_click', button.label),
    icon: button != null && button.prefixIcon ? {
      name: button.prefixIcon,
      place: 'prefix'
    } : undefined,
    sideEffect: button.sideEffect,
    disabled: areControlsDisabled,
    priority: (button == null ? void 0 : button.priority) || 'secondary'
  }, button.label)))));
};
export const RESTORE_NOTIFICATION_WIDGET = 'RESTORE_NOTIFICATION_WIDGET';
//# sourceMappingURL=RestoreNotificationWidget.js.map